import { TAB_PANEL_CLASS_NAME } from "Common/componentUtils/constants";
import classNames from "classnames";
import React from "react";
export default function TabPanel(props) {
    const { children, className, ...other } = props;
    const childrenElt = children ? React.Children.toArray(children)[0] : null;
    return (React.createElement("div", { className: classNames(TAB_PANEL_CLASS_NAME, "overflow-hidden", className), ...other }, childrenElt));
}
